/** Geteilte Feld-Styles der Akte-Ordner-Dialoge (Input + Label). */
export const dialogInputClass =
  'border-line bg-card text-ink w-full rounded-md border px-3 py-2 text-sm outline-none focus:border-sealwax';
export const dialogLabelClass =
  'text-ink-soft mb-1 block text-xs font-medium uppercase tracking-wider';
